/**
 * @generated SignedSource<<61df75318f5cfbf27f4caa0a3217d798>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberModalRow_Member$data = {
  readonly firstName: string | null | undefined;
  readonly id: string;
  readonly lastName: string | null | undefined;
  readonly profileImage: {
    readonly publicId: string;
  } | null | undefined;
  readonly " $fragmentType": "MemberModalRow_Member";
};
export type MemberModalRow_Member$key = {
  readonly " $data"?: MemberModalRow_Member$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberModalRow_Member">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberModalRow_Member",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "profileImage",
      "plural": false,
      "selections": [
        {
          "alias": "publicId",
          "args": null,
          "kind": "ScalarField",
          "name": "renderingKey",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Member",
  "abstractKey": null
};

(node as any).hash = "faab558ab8d9f1d817c6873215eb19c8";

export default node;
